import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0821b7da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "history-list"
}
const _hoisted_2 = { class: "history-list-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_6 = { class: "item-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "price" }

import { getUserBrowsingHistory } from '@/apis/user'
import { useUserStore } from '@/stores'
import { onMounted, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryList',
  setup(__props) {

const userStore = useUserStore()
const $router = useRouter()
const $route = useRoute()
const handleClick = (item) => {
  const id = item.goodsId.slice(2)
  const source = item.source
  if ($route.query.id === id && $route.query.source === source) {
    return
  } else {
    $router.push({ query: { ...$route.query, id, source } })
  }
}
const state = reactive({
  list: [] as any[],
  page: 0,
})
onMounted(() => {
  getUserBrowsingHistory().then((res) => {
    state.page = Math.ceil(res.length / 5)
    state.list = res
  })
  state
})

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (state.list.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('product.recentlyViewed')), 1),
          _hoisted_5
        ]),
        _createVNode(_component_el_carousel, {
          loop: false,
          autoplay: false,
          arrow: "always",
          "indicator-position": "outside"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.page, (page) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: page }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.list.slice(page * 5 - 5, page * 5), (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item",
                        key: item.id,
                        onClick: ($event: any) => (handleClick(item))
                      }, [
                        _createElementVNode("img", {
                          src: item.goodsImg
                        }, null, 8, _hoisted_8),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(userStore).language === 'cn' ? item.goodsTitle : item.goodsTitleEn), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(userStore).currencyUnit) + " " + _toDisplayString(_ctx.$flatRateOrigin(item.goodsPrice, _unref(userStore).rate)), 1)
                      ], 8, _hoisted_7))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})